import axios from 'axios';

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:8080',
  timeout: 15000,
  headers: { 'Content-Type': 'application/json; charset=utf-8' },
});

apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('token') || sessionStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// ─── Interfaces ────────────────────────────────────────────────

export interface FH130 {
  fh130_01: string;
  fh130_11: string | null;   // 沖帳日期
  fh130_12: number;          // 原幣沖帳總額
  fh130_13: number;          // 沖帳總額(整數)
  fh130_14: string;          // 公司/員工類別
  fh130_15: string;          // 公司/員工代號
  fh130_16: string;          // 幣別
  fh130_17: number;          // 匯率
  fh130_18: number;          // 原幣實付總額
  fh130_19: string;          // 部門代號
  fh130_20: number;          // 明細筆數
  fh130_21: string | null;   // 建立日期
  fh130_80: string;          // 核准狀態 N/P
  fh130_81: string;
  fh130_90: number;          // version
  fh130_91: string;
  fh130_92: string | null;
  fh130_93: string;
  details?: FH131[];
}

export interface FH131 {
  fh131_01: string;          // 沖帳單號 (FK)
  fh131_02: number;          // 明細序號
  fh131_11: string;          // 請款單號
  fh131_12: string;          // 付款方式
  fh131_13: string;          // 銀行帳號
  fh131_14: string;          // 票據號碼
  fh131_15: string | null;   // 支票到期日
  fh131_16: string;          // 幣別
  fh131_17: number;          // 請款金額
  fh131_18: number;          // 匯率
  fh131_19: string;          // 廠商代號
  fh131_20: string;          // 請款類別
  fh131_21: string;          // 銀行代號
  fh131_22: number;          // 實付金額
  fh131_23: string;          // 受款人
  fh131_24: string | null;   // 備用日期
  fh131_25: number;
  fh131_261: boolean;
  fh131_262: boolean;
  fh131_27: boolean;
  fh131_90: number;
  expenses?: FH132[];
}

export interface FH132 {
  fh132_01: string;          // 沖帳單號 (FK)
  fh132_02: number;          // 明細序號 (FK)
  fh132_03: number;          // 費用序號
  fh132_10: string;          // 費用代號
  fh132_11: string;          // 廠商代號
  fh132_12: string;          // 備用代碼
  fh132_13: number;          // 費用金額
}

export interface CreateRequest {
  master: FH130;
  details: FH131[];
  expenses: FH132[];
}

export interface ListResponse {
  data: FH130[];
  total: number;
  page: number;
  size: number;
}

// ─── API Methods ────────────────────────────────────────────────

export const pwh203Api = {
  list(page = 1, size = 20): Promise<ListResponse> {
    return apiClient
      .get('/api/pwh203', { params: { page, size } })
      .then((r) => r.data);
  },

  get(id: string): Promise<FH130> {
    return apiClient.get(`/api/pwh203/${encodeURIComponent(id)}`).then((r) => r.data);
  },

  create(payload: CreateRequest): Promise<FH130> {
    return apiClient.post('/api/pwh203', payload).then((r) => r.data);
  },

  update(id: string, payload: CreateRequest): Promise<FH130> {
    return apiClient
      .put(`/api/pwh203/${encodeURIComponent(id)}`, payload)
      .then((r) => r.data);
  },

  delete(id: string): Promise<void> {
    return apiClient.delete(`/api/pwh203/${encodeURIComponent(id)}`).then(() => undefined);
  },
};
